export default __webpack_public_path__ + "static/media/native.cf348282.png";